export const CUSTOM_DOCTOR_ERX_DETAILS = (details) => {
  return `clinic/v1/clinic/${details.clinicId}/doctor_profile`;
};

export const GET_DOCTOR_ERX_DETAILS = (details) => {
  return `clinic/${details.clinicId}/${
    details.doctorId
  }/get_doctor_custom_rx_details${
    details.hasOwnProperty("isReset")
      ? `?custom_erx_enabled=${details?.isReset}`
      : ""
  }`;
};

export const PDF_GENERATOR = "/user/pdfgenerator";
